import React, { FC } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const TableLoader: FC<{ colSpan: number }> = ({ colSpan }) => {
  return (
    <>
      {Array.from([1, 2, 3, 4, 5], (x: number) => (
        <TableRow key={`loading_row_${x}`}>
          <TableCell colSpan={colSpan}>
            <Skeleton animation="wave" variant="text" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export { TableLoader };
